// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1140":"dd55e1cf2dab9870eea9","2221":"5cdd551ed83d9a12c3ed","5448":"71cfe268d6f1213c4735","5862":"580b9c2e231a9169a12f","6015":"8ac07126adf0759a3464","7859":"5bcb1bbacda3204063dd","7910":"de857920f8beb5205bbc","8815":"0f63c2eb085d7b08be1b"}[chunkId] + "";
};